import { createFileRoute } from "@tanstack/react-router";
import type { SearchSchemaInput } from "@tanstack/react-router";
import { SectionPage } from "@/components/SectionPage";
import { RelatedHubs } from "@/components/RelatedHubs";
import { getSeoHappeningItems } from "@/lib/seo.functions";
import { buildHreflangLinks, buildLocaleMeta } from "@/lib/i18n-paths";

export const Route = createFileRoute("/fi/happening/")({
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput): { q?: string; page?: number } => ({
    q: typeof search.q === "string" ? search.q : undefined,
    page: Number(search.page) > 0 ? Number(search.page) : 1,
  }),
  loader: async () => {
    try {
      const { items } = await getSeoHappeningItems({ data: { limit: 30 } });
      return { items };
    } catch {
      return { items: [] };
    }
  },
  head: ({ loaderData }) => {
    const items = loaderData?.items ?? [];
    const url = "https://whatfinland.com/fi/happening";
    const itemList = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Mitä tapahtuu Suomessa — konsertit, festivaalit ja näyttelyt",
      url,
      inLanguage: "fi",
      numberOfItems: items.length,
      itemListElement: items.map((it, i) => ({
        "@type": "ListItem",
        position: i + 1,
        url: `https://whatfinland.com/fi/happening/${it.slug}`,
        name: it.name,
      })),
    };
    return {
      meta: [
        { title: "Mitä tapahtuu Suomessa — Konsertit, Festivaalit & Näyttelyt" },
        { name: "description", content: "Päivittäin päivittyvä kalenteri konserteista, festivaaleista ja kulttuuritapahtumista Helsingissä, Turussa ja Tampereella." },
        { property: "og:title", content: "Mitä tapahtuu — Suomi" },
        { property: "og:description", content: "Live-tapahtumakalenteri ympäri Suomea." },
        { property: "og:url", content: url },
        ...buildLocaleMeta("fi"),
      ],
      links: [
        { rel: "canonical", href: url },
        ...buildHreflangLinks("/fi/happening"),
      ],
      scripts: [{ type: "application/ld+json", children: JSON.stringify(itemList) }],
    };
  },
  component: () => (
    <>
      <SectionPage section="happening" />
      <RelatedHubs current="happening" />
    </>
  ),
});
